import LogoColored from '@/shared/assets/icons/logo-colored.svg?react';
import { getAppsRoute } from '@/shared/const/router.const';
import { cn } from '@/shared/lib/shadcn/utils';
import { Button } from '@/shared/ui/shadcn/ui/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

type IServicePageProps = {
  title: string;
  description: string;
  image: React.ReactNode;
  wrapperClassName?: string;
  buttonText?: string;
  ns?: string;
  onReset?: () => void;
};

export const ServicePage: FC<IServicePageProps> = (props) => {
  const {
    title,
    description,
    image,
    wrapperClassName,
    buttonText = 'На главный экран',
    ns = 'translation',
    onReset,
  } = props;
  const { t } = useTranslation(ns);

  return (
    <div
      className={cn(
        'relative flex h-full w-full flex-col items-center justify-center',
        wrapperClassName,
      )}
    >
      <LogoColored className="absolute top-7 left-20" />
      <div className="mb-8">{image}</div>
      <div className="mb-10 text-center">
        <h1 className="text-40 mb-3 leading-[1.4] font-bold">{title}</h1>
        <div className="text-20 leading-[1.2] font-semibold">{description}</div>
      </div>
      <>
        {onReset ? (
          <Button size="lg" onClick={onReset}>
            {t(buttonText)}
          </Button>
        ) : (
          <Button size="lg" asChild>
            <Link to={getAppsRoute()}>{t(buttonText)}</Link>
          </Button>
        )}
      </>
    </div>
  );
};
